import * as React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useFlowFSStore } from "../state/flowfs-store";
import { useShallow } from "zustand/react/shallow";
import { toast } from "sonner";

export default function TopBar({ tenantId, flowId }: { tenantId: string; flowId: string }) {
  const { prefix, setPrefix, recursive, setRecursive, limit, setLimit } = useFlowFSStore(
    useShallow((s) => ({
      prefix: s.prefix,
      setPrefix: s.setPrefix,
      recursive: s.recursive,
      setRecursive: s.setRecursive,
      limit: s.limit,
      setLimit: s.setLimit,
    }))
  );
  const [localPrefix, setLocalPrefix] = React.useState(prefix);

  const onApply = () => {
    if (!localPrefix.startsWith("/") || localPrefix.includes("..")) {
      toast.error("Path must be absolute and free of '..'");
      return;
    }
    setPrefix(localPrefix);
  };

  return (
    <div className="border-b p-2 flex gap-3 items-end">
      <div className="grid gap-1">
        <Label>Tenant</Label>
        <Input value={tenantId} readOnly />
      </div>
      <div className="grid gap-1">
        <Label>Flow</Label>
        <Input value={flowId} readOnly />
      </div>
      <div className="grid gap-1 min-w-[360px] flex-1">
        <Label>Prefix (absolute)</Label>
        <Input value={localPrefix} onChange={(e) => setLocalPrefix(e.target.value)} placeholder="/" />
      </div>
      <div className="grid gap-1 w-[160px]">
        <Label>Recursive</Label>
        <label className="h-9 flex items-center gap-2 px-2 text-sm">
          <input type="checkbox" checked={recursive} onChange={(e) => setRecursive(e.target.checked)} />
          <span>Include subfolders</span>
        </label>
      </div>
      <div className="grid gap-1 w-[120px]">
        <Label>Limit</Label>
        <Input
          type="number"
          min={10}
          max={500}
          value={limit}
          onChange={(e) => setLimit(Number(e.target.value || 100))}
        />
      </div>
      <Button onClick={onApply}>Search</Button>
    </div>
  );
}
